import React from "react";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { MainPageWithButtons, ListedGroup, SimpleListElement, CapsuleButton } from "../_components";
import { Product } from "../_models/Product";
import { PRODUCTS_MODULE_UI_CONSTANTS } from "./ProductsModuleUIConstants";

import { ProductsActions } from "../_actions/ProductsActions";
import { BudgetsStore } from "../_reducers/budgetsRootReducer";

export function ProductsListView({
    products = [] || [Product()],
    secondaryView,
    handleClickProduct = () => {},
    selectedProductUid,
}) {

    //LIBRARIES
    const { t } = useTranslation();
    const dispatch = useDispatch();

    // LOCAL
    const budgetUser = useSelector(BudgetsStore.selectors.getBugetUser);

    //VIEW
    return (
        <MainPageWithButtons
            pageTitle={t("mod_products_title")}
            content={content()}
            buttons={createButtons()}
        />
    );

    function content() {
        return products.length
            ? producstList()
            : noProductsMessage()
        ;

        function producstList() {
            return (
                <div className="mt-2">
                    <ListedGroup
                        elements={products.map(singleProduct)}
                    />
                </div>
            );
        }

        function noProductsMessage() {
            return (
                <div className="mt-2 text-center">
                    {t("mod_products_no_items_found")}
                </div>
            );
        }

        function singleProduct(product = Product()) {
            return (
                <SimpleListElement
                    isSelected={product.uid === selectedProductUid}
                    onClick={() => handleClickProduct(product.uid)}
                    text={product.name}
                />
            );
        }
    }

    function createButtons() {
        if (budgetUser.budgetUser.isManager)
            return [
                <CapsuleButton
                    onClick={handleCreateNewProduct}
                    text={t("global_add")}
                    isSelected={secondaryView === PRODUCTS_MODULE_UI_CONSTANTS.SECONDARY_VIEWS.NEW_PRODUCT}
                />
            ];
    }

    //ACTION HANDLERS
    function handleCreateNewProduct() {
        dispatch(ProductsActions.changeSecondaryView(PRODUCTS_MODULE_UI_CONSTANTS.SECONDARY_VIEWS.NEW_PRODUCT));
    }
}